import { Alert, Button, Card, Outcome, PageHeading } from '@aulaviva/ui';
import { Building2, CircleX, Wifi } from 'lucide-react';
import { useState } from 'react';
import { Link, useParams } from 'react-router';
import { useAzioneLinkConferma, useLinkConferma, type AzioneLink } from '@/api/percorsi';
import { formattaIntervallo } from '@/lib/date';
import { comuni, percorsi } from '@/testi';

/** Dal link nell'email di invito: conferma online, in sala o rinuncia, senza accesso. */
export function ConfermaLink() {
  const t = percorsi.link;
  const { token = '' } = useParams();
  const info = useLinkConferma(token);
  const azione = useAzioneLinkConferma(token);
  const [esito, setEsito] = useState<AzioneLink | null>(null);

  if (info.isPending) return <p className="t-body text-ink-muted">{comuni.caricamento}</p>;
  if (info.isError)
    return (
      <>
        <PageHeading subtitle={t.nonValidoTesto}>{t.nonValido}</PageHeading>
        <Link to="/accedi">
          <Button variant="primary">{t.vaiAlPercorso}</Button>
        </Link>
      </>
    );

  const d = info.data;
  const statoAttuale =
    d.conferma.stato === 'confermato'
      ? d.conferma.modalita === 'sala'
        ? percorsi.stati.confermatoSala
        : percorsi.stati.confermatoOnline
      : d.conferma.stato === 'rinunciato'
        ? percorsi.stati.rinunciato
        : null;

  async function esegui(a: AzioneLink) {
    setEsito(null);
    await azione.mutateAsync(a);
    setEsito(a);
  }

  return (
    <>
      <PageHeading subtitle={t.saluto(d.nome)}>{t.titolo}</PageHeading>
      <Card className="flex flex-col gap-2">
        <p className="t-title-3">{d.webinar.titolo}</p>
        <p className="t-body text-ink-muted">{formattaIntervallo(d.webinar.inizioPrevisto, d.webinar.finePrevista)}</p>
      </Card>
      {esito ? (
        <Outcome variant={esito === 'rinuncia' ? 'warning' : 'success'} title={esito === 'conferma_online' ? t.esitoOnline : esito === 'conferma_sala' ? t.esitoSala : t.esitoRinuncia}>
          {t.esitoTesto}
        </Outcome>
      ) : (
        statoAttuale && <Alert variant="info" title={t.giaScelto(statoAttuale)} />
      )}
      {azione.isError && <Alert variant="error" title={azione.error.message} />}
      <div className="flex flex-col gap-3">
        <Button variant="primary" size="lg" icon={Wifi} onClick={() => esegui('conferma_online')} loading={azione.isPending && azione.variables === 'conferma_online'}>
          {t.online}
        </Button>
        <Button size="lg" icon={Building2} onClick={() => esegui('conferma_sala')} loading={azione.isPending && azione.variables === 'conferma_sala'}>
          {t.sala}
        </Button>
        <Button variant="discreet" icon={CircleX} onClick={() => esegui('rinuncia')} loading={azione.isPending && azione.variables === 'rinuncia'}>
          {t.rinuncia}
        </Button>
      </div>
      <p className="t-body text-ink-muted">
        <Link to="/accedi">{t.vaiAlPercorso}</Link>
      </p>
    </>
  );
}
